const state = {
  newMember: {
    // chinese_commercial_code: '1234 1234 1234',
    // date_of_birth: '01-01-1990',
    // date_of_issue: '01-01-22',
    // gender: 'M',
    // hkid: 'A123456(7)',
    // is_permanent_resident: 'xxx',
    // name: 'xxx',
    // name_en: 'xxx',
    chinese_commercial_code: '',
    date_of_birth: '',
    date_of_issue: '',
    gender: '',
    hkid: '',
    is_permanent_resident: '',
    name: '',
    name_en: '',
    init: true,
  },
  orderInfo: {
    courseID: 1,
    orderTypeID: 1,
    programID: 1,
    programPriceID: 1,
    promotionID: 0,

    // effectiveDate: '2023-01-10',
    effectiveDate: '',
    selectedCoachList: [
      {
        id: -1,
      },
    ],
  },
}

const mutations = {
  SET_NEW_MEMBER: (state, newMember) => {
    state.newMember = newMember
    state.newMember.init = false
  },
  SET_ORDERINFO: (state, orderInfo) => {
    state.orderInfo = orderInfo
  },
}

const actions = {
  saveNewMember({ commit }, newMemember) {
    return new Promise((resolve, reject) => {
      commit('SET_NEW_MEMBER', newMemember)
      resolve(newMemember)
    })
  },
  resetNewMember({ commit }) {
    return new Promise((resolve, reject) => {
      const defaultSetting = {
        // chinese_commercial_code: '1234 1234 1234',
        // date_of_birth: '01-01-1990',
        // date_of_issue: '01-01-22',
        // gender: 'M',
        // hkid: 'A123456(7)',
        // is_permanent_resident: 'xxx',
        // name: 'xxx',
        // name_en: 'xxx',
        chinese_commercial_code: '',
        date_of_birth: '',
        date_of_issue: '',
        gender: '',
        hkid: '',
        is_permanent_resident: '',
        name: '',
        name_en: '',
        init: true,
      }
      commit('SET_NEW_MEMBER', defaultSetting)
      resolve(defaultSetting)
    })
  },
  resetOrderInfo({ commit }) {
    return new Promise((resolve, reject) => {
      const defaultSetting = {
        courseID: 1,
        orderTypeID: 1,
        programID: 1,
        programPriceID: 1,
        promotionID: 1,

        // effectiveDate: '2023-01-10',
        effectiveDate: '',
        selectedCoachList: [
          {
            id: 1,
          },
          {
            id: 2,
          },
        ],
        init: true,
      }
      commit('SET_ORDERINFO', defaultSetting)
      resolve(defaultSetting)
    })
  },
  saveOrderInfo({ commit }, orderInfo) {
    return new Promise((resolve, reject) => {
      commit('SET_ORDERINFO', orderInfo)
      resolve(orderInfo)
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
